import React from 'react'
import styles from '../styles'
import { NavLink } from 'react-router-dom'

const HeaderUserInfoView = ({ name, role, dropDownOpened, toggleDropDown }) => (
  <section style={styles.container}>
    <div styles={styles.dropDownWrapper}>
      <div
        onClick={toggleDropDown}
        style={styles.mediumText}
        cypress_id="header_user_name_block"
      >
        {name} <i style={dropDownOpened ? styles.arrowUp : styles.arrowDown} />
      </div>
      <div
        style={
          dropDownOpened
            ? styles.dropdownContainerOpened
            : styles.dropdownContainerHidden
        }
      >
        <NavLink to="/dashboard/profile" style={styles.dropdownItem}>
          Profile
        </NavLink>
        <NavLink
          to={'/logout'}
          style={styles.dropdownItem}
          cypress_id="header_dropdown_logout_button"
        >
          Logout
        </NavLink>
      </div>
    </div>
    <div style={styles.smallItalicText}>{role}</div>
  </section>
)

export default HeaderUserInfoView
